import { render } from "./StockTransfers.vue?vue&type=template&id=18abea46&scoped=true"
import script from "./StockTransfers.vue?vue&type=script&lang=js"
export * from "./StockTransfers.vue?vue&type=script&lang=js"

import "./StockTransfers.vue?vue&type=style&index=0&id=18abea46&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18abea46"]])

export default __exports__